import { useCallback } from 'react';

import { AppointmentPatient } from '@dreryk/egabinet-appointment-frontend-api';

import { Text, TextSeparator, TextSeparatorType, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';
import { getPatientName } from '~libs.desktop.shared.appointments-timetable';

import { calendarTranslationKeys } from '../../../../../translations';

import { StyledLink } from './PatientHeading.styled';

type PatientHeadingProps = Readonly<{ patient: AppointmentPatient }>;

export const PatientHeading = (props: PatientHeadingProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(false);

   const goToPatientUpdateForm = useCallback((): void => {
      push(patientPaths.getDataPath(props.patient.id), {
         label: calendarTranslationKeys.goBackToCalendar,
      });
   }, [push, props.patient.id]);

   return (
      <StyledLink
         testId={'patient'}
         onClick={goToPatientUpdateForm}
         label={
            <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
               <Text testId={'patientName'}>{getPatientName(props.patient)}</Text>
               {props.patient.formattedAge ? <Text testId={'age'}>{props.patient.formattedAge}</Text> : null}
            </TextSeparator>
         }
      />
   );
};
